/**
 * Collects client-side context for support queries.
 *
 * This data is sent with every support request and logged server-side to help
 * diagnose bug reports. It is never included in the support email itself.
 */
export const collectClientContext = (): Record<string, string> => {
  if (typeof window === 'undefined') return {};

  return {
    url: window.location.href,
    referrer: document.referrer || 'direct',
    userAgent: navigator.userAgent,
    language: navigator.language,
    languages: navigator.languages?.join(', ') ?? '',
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    viewportSize: `${window.innerWidth}x${window.innerHeight}`,
    devicePixelRatio: String(window.devicePixelRatio ?? 1),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    onLine: String(navigator.onLine),
    platform: navigator.platform,
    timestamp: new Date().toISOString()
  };
};
